// Labels and small helpers for the ticket screens (Phase 7).
export const STATUS_CLASS = {
    Open: "tk-st-open",
    "In Progress": "tk-st-progress",
    "Waiting on customer": "tk-st-waiting",
    Resolved: "tk-st-resolved",
    Closed: "tk-st-closed",
};
export const PRIORITY_LABEL = { low: "Low", normal: "Normal", high: "High", urgent: "Urgent" };
export const PRIORITY_CLASS = { low: "tk-pr-low", normal: "tk-pr-normal", high: "tk-pr-high", urgent: "tk-pr-urgent" };
export const PRIORITIES = ["low", "normal", "high", "urgent"];

export const EVENT_LABEL = {
    created: "Raised",
    taken: "Taken",
    assigned: "Assigned",
    reassigned: "Reassigned",
    appealed: "Appealed to admin",
    appeal_taken: "Admin took the appeal",
    returned: "Returned",
    escalated: "Escalated to admin (SLA)",
    status: "Status changed",
    priority: "Priority changed",
    sla_warning: "SLA warning",
    sla_breach: "SLA missed",
    reopened: "Reopened",
    resolved: "Resolved",
    closed: "Closed",
    rated: "Rated",
};

const IN = "en-IN";
export const when = (value) => (value ? new Date(value).toLocaleString(IN, { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : "");
export const dayText = (value) => (value ? new Date(value).toLocaleDateString(IN, { day: "numeric", month: "short", year: "numeric" }) : "");

// "2 h 5 m", "3 d 4 h", "12 m"
export const duration = (ms) => {
    const minutes = Math.max(0, Math.round(Math.abs(ms) / 60000));
    if (minutes < 60) return `${minutes} m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 48) return `${hours} h${minutes % 60 ? ` ${minutes % 60} m` : ""}`;
    return `${Math.floor(hours / 24)} d${hours % 24 ? ` ${hours % 24} h` : ""}`;
};

// One SLA clock as a short line and a colour: "Reply due in 1 h 20 m", "Resolution overdue by 2 h", "Met".
export const clockText = (clock, label, paused, now = Date.now()) => {
    if (!clock) return null;
    if (clock.done) return { text: `${label}: ${clock.met ? "met" : "missed"}`, tone: clock.met ? "ok" : "bad" };
    if (paused) return { text: `${label}: paused (waiting on the customer)`, tone: "muted" };
    const due = clock.dueAt ? new Date(clock.dueAt).getTime() : null;
    if (!due) return { text: `${label}: ${clock.percent}% used`, tone: "muted" };
    const left = due - now;
    if (left < 0) return { text: `${label} overdue by ${duration(left)}`, tone: "bad" };
    return { text: `${label} due in ${duration(left)}`, tone: clock.percent >= 80 ? "warn" : "ok" };
};

export const slaSummary = (ticket) => {
    const s = ticket?.slaState;
    if (!s) return null;
    if (["Resolved", "Closed"].includes(ticket.status)) return clockText(s.resolution, "Resolution", false);
    if (s.response && !s.response.done) return clockText(s.response, "First reply", s.paused);
    return clockText(s.resolution, "Resolution", s.paused);
};

export const raiserText = (ticket) => {
    const r = ticket?.raisedBy || {};
    return `${r.name || r.id || "-"}${r.id ? ` (${r.id})` : ""}`;
};
export const assigneeText = (ticket) => {
    if (ticket?.appeal?.active) return ticket.appeal.by === "system" ? "Admin queue (escalated)" : "Admin queue (appealed)";
    if (!ticket?.assignee?.id) return "Pool";
    return `${ticket.assignee.name || ticket.assignee.id}${ticket.assignee.type === "admin" ? " (admin)" : ""}`;
};

export const fileName = (url) => {
    try { return decodeURIComponent(String(url).split("/").pop().split("?")[0]) || "file"; } catch (error) { return "file"; }
};
export const isImage = (url) => /\.(jpe?g|png|webp|gif)(\?|$)/i.test(String(url));
